import { render } from "./videocall_popup.vue?vue&type=template&id=1380e626&scoped=true"
import script from "./videocall_popup.js?vue&type=script&lang=js"
export * from "./videocall_popup.js?vue&type=script&lang=js"

import "./videocall_popup.vue?vue&type=style&index=0&id=1380e626&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1380e626"]])

export default __exports__